import React, {createContext, useCallback, useContext, useState} from 'react';
import {Language, LocaleLanguage} from './i18nTypes';
import {getCurrentLanguage} from './i18n-service';

type NumberFormatOptions = {
    formatNumber: (value: any) => string;
    selectedLanguage: Language;
}

// Create a context
let NumberFormatContext: React.Context<NumberFormatOptions>;

// Create a provider component
export const LocalizationProvider = ({children}) => {
    const [fractionDigits] = useState<{
        minimumFractionDigits: number,
        maximumFractionDigits: number
    }>({minimumFractionDigits: 0, maximumFractionDigits: 10});
    const selectedLanguage = getCurrentLanguage();
    const [locale,] = useState(LocaleLanguage.getLocaleLanguage(selectedLanguage).locale);

    const formatNumber = useCallback((value) => {
        return new Intl.NumberFormat(locale, fractionDigits).format(value);
    }, [locale, fractionDigits]);


    NumberFormatContext = createContext<NumberFormatOptions>({formatNumber, selectedLanguage});

    return (
        <NumberFormatContext.Provider value={{formatNumber, selectedLanguage}}>
            {children}
        </NumberFormatContext.Provider>
    );
};

// Custom hook to use the number format context
export const useLocalizationUtil = () => {
    return useContext(NumberFormatContext);
};
